import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";


export class BaseCache<T>{
  refreshingPromise :Promise<T>;
  refreshingDate ?:Date;
  refresher :()=>Promise<T>
  datas :T;
  subscriptions : ((a:T)=>any)[] = [];

  constructor(refresher : ()=>Promise<T>){
    this.refresher = refresher;
    amplify.subscribe("familyScopeChange sessionExpired familyChange",()=>{
      this.kill();
    });
  }
  //return a promise that will return fresh datas
  async refresh() :Promise<T>{
    if(this.refreshingPromise){
      return this.refreshingPromise
    }
    try{
      this.refreshingPromise = this.refresher();
      this.datas = await this.refreshingPromise
      this.refreshingDate = new Date();
      this.subscriptions.forEach(sub=>sub(this.datas))
      return (this.datas)
    }finally{
      this.refreshingPromise = undefined;
    }
    
  }
  //return a promise that will update the data if needed or old
  async need(){
    if(this.refreshingDate && (new Date().getTime()-this.refreshingDate.getTime())<60000){
      return this.datas;
    }else{
      return this.refresh();
    }
  }
  //mark it for refresh needed
  invalidate(){
    this.refreshingDate = undefined;
  }
  //kill this cache
  kill(){
    this.datas = undefined;
    this.refreshingDate = undefined;
  }
  subscribe(callback){
    this.subscriptions.push(callback);
  }
  unsubscribe(callback){
    var idx = this.subscriptions.indexOf(callback);
    if(idx!==-1){
      this.subscriptions.splice(idx,1);
    }
  }
}
export class ListCache<T extends {metaId:string}> extends BaseCache<(T)[]>{
  constructor(api : ()=>Promise<T[]>, comparator :(a:T,b:T)=>number = undefined){
    super(async ()=>{
      var datas = await api();
      if(comparator){
        datas.sort(comparator);  
      }
      return datas;
    })
    this.datas = [];
    
  }
  //get an element in the current cache out of date or not
  get(metaId :string){
    for(let i=0;i<this.datas.length;i++){
      if(this.datas[i].metaId===metaId) return this.datas[i]
    }
    return null;
  }
  override kill(){
    super.kill()
    this.datas = [];
  }
}

export class SyncCache<T extends {metaId:string}> extends ListCache<T>{
  syncToken : string;
  constructor(api :(request:{syncToken :string|undefined})=>Promise<SyncBean<T>>, comparator :(a:T,b:T)=>number = undefined){
    super(async ()=>{
      var syncBean = await api({syncToken:this.syncToken})
      this.syncToken = syncBean.syncToken;
      FwDatas.mergeSyncBean(syncBean,this.datas);
      return this.datas;
    }, comparator)
  }
  
  override kill(){
    super.kill()
    this.syncToken = undefined;
  }
}

export class MetaCache4<A,B,C,D> extends BaseCache<[A,B,C,D]>{
  subCaches :[BaseCache<A>,BaseCache<B>,BaseCache<C>,BaseCache<D>];
  
  constructor(postHandle:(a:A,b:B,c:C,d:D)=>void,a :BaseCache<A>, b:BaseCache<B>, c:BaseCache<C>, d:BaseCache<D>){
    super(async ()=>{
      var data = await Promise.all([a.refresh(),b.refresh(),c.refresh(),d.refresh()])
      postHandle(...data)
      return data;
    })
    this.subCaches = [a,b,c,d];
  }
  override invalidate(){
    super.invalidate();
    this.subCaches.forEach(sub=>sub.refreshingDate = undefined)
  }
  override kill(){
    super.kill();
    this.subCaches.forEach(sub=>sub.kill())
  }
}

export class TranslationCache<T,O> extends BaseCache<T[]>{
  originalCache : BaseCache<O[]>;
  constructor(originalCache : BaseCache<O[]>, translator : (o:O[])=>T[]){
    super(async ()=>{
      var data = await originalCache.refresh()
      return translator(data);
    })
    this.originalCache = originalCache;
  }
  override async need(){
    return this.refresh();
  }
}